import React, { useState, useRef, useEffect } from 'react';
import { MoreVertical, User, Edit, Key } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const ProfileMenu: React.FC = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleMenuItemClick = (path: string) => {
    setIsOpen(false);
    navigate(path);
  };

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-2 pr-0 hover:bg-gray-100 rounded-lg transition-colors"
        aria-label="Profile menu"
      >
        <MoreVertical className="w-6 h-6 text-white" />
      </button>

      {isOpen && (
        <div 
          className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border-4 border-[#077f5d] py-2 z-50"
        >
          <button
            onClick={() => handleMenuItemClick('/profile')}
            className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
          >
            <User className="w-4 h-4" />
            {t('profile.title')}
          </button>
          {/*
          <button
            onClick={() => handleMenuItemClick('/profile/edit')}
            className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
          >
            <Edit className="w-4 h-4" />
            Edit Profil
          </button>
          <button
            onClick={() => handleMenuItemClick('/profile/change-password')}
            className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
          >
            <Key className="w-4 h-4" />
            Ubah Password
          </button>
          */}
        </div>
      )}
    </div>
  );
};
